import type { Mode } from "../../../components/general/types/Modify";
import { api } from "../../../services/jobpermissions.service";
import { useJobPermission } from "./useJobPermission";

const permission = ["CopyMyJob", "CopyAnyUserJobs"];

export const useCanCopyJob = (mode: Mode, fetch: boolean) =>
  useJobPermission(mode, fetch, api.copyJob, permission);
